/* ======= 折叠式移动端菜单逻辑（一级与二级均可折叠） ======= */
document.addEventListener('DOMContentLoaded', () => {
  // 获取所有触发按钮
  const triggers = document.querySelectorAll('.collapsible-trigger');

  triggers.forEach(trigger => {
    trigger.addEventListener('click', e => {
      e.preventDefault();

      const targetId = trigger.getAttribute('aria-controls');
      const target = document.getElementById(targetId);
      const expanded = trigger.getAttribute('aria-expanded') === 'true';

      // 折叠同层其他展开项（保持单开逻辑）
      const siblingTriggers = trigger.closest('ul').querySelectorAll('.collapsible-trigger');
      siblingTriggers.forEach(other => {
        if (other !== trigger) {
          const otherTarget = document.getElementById(other.getAttribute('aria-controls'));
          if (otherTarget) {
            otherTarget.classList.remove('is-open');
          }
          other.setAttribute('aria-expanded', 'false');
        }
      });

      // 当前项展开/收起
      trigger.setAttribute('aria-expanded', !expanded);
      target.classList.toggle('is-open', !expanded);
    });
  });
});
